// POST /v1/session/active-account (contracts.md:52 "Onboarding/app API surface" -
// "active-account selection POST /v1/session/active-account (validated against
// memberships)"). CONTRACT GAP: no dedicated wire schema is cited for the response
// envelope. Composed here from two already-frozen shared schemas (`Account`,
// `Membership` - packages/shared/src/model/identity.ts:11,33), never a hand-rolled
// shape; confirm the exact envelope with the tech-lead/apps/api lane.
import { z } from "zod";
import { Account, Membership } from "@nightcrew/shared";
import type { Result } from "@nightcrew/shared";
import { apiPost } from "./client.js";
import type { ClientError } from "./errors.js";

export const ActiveAccountResponse = z.object({
  account: Account,
  membership: Membership,
});
export type ActiveAccountResponse = z.infer<typeof ActiveAccountResponse>;

/** Select (or confirm) the session's active account. No body: the server resolves the
 * founder's membership set and picks the sole/most-recent account (multi-account
 * account switching is out of Slice 2 scope). */
export const selectActiveAccount = (): Promise<Result<ActiveAccountResponse, ClientError>> =>
  apiPost("/v1/session/active-account", ActiveAccountResponse, {});
